import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-TQV7XJK',
        },
    },
    host: 'www.zalando-lounge.ro',
});
